import { render, staticRenderFns } from "./TeacherViewTabClass.vue?vue&type=template&id=0f968a68&"
import script from "./TeacherViewTabClass.vue?vue&type=script&lang=js&"
export * from "./TeacherViewTabClass.vue?vue&type=script&lang=js&"
import style0 from "./TeacherViewTabClass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports